import { doLogout } from "actions/authAction";

import {
  BASE_URL,
  SCHEDULE_URL,
  SCHEDULE_GET_ERROR,
  SCHEDULE_GET_LOADING,
  SCHEDULE_GET_SUCCESS,
  SCHEDULE_VIEW_ERROR,
  SCHEDULE_VIEW_LOADING,
  SCHEDULE_VIEW_SUCCESS,
  SCHEDULE_ADD_ERROR,
  SCHEDULE_ADD_LOADING,
  SCHEDULE_ADD_SUCCESS,
  SCHEDULE_DELETE_ERROR,
  SCHEDULE_DELETE_LOADING,
  SCHEDULE_DELETE_SUCCESS,
  SCHEDULE_GET_BOOKING,
  SCHEDULE_APPROVE_OR_CANCEL_CONTAINER,
  SCHEDULE_GET_CONTAINER_FROM_BOOKING,
  SCHEDULE_APPROVE_CANCEL_BOOKING,
  SCHEDULE_ADD_INVALID,
  SCHEDULE_GET_HISTORY,
  SCHEDULE_GET_VOYAGE,
  SCHEDULE_UBAH_COMMITTED,
} from "./constant";
import { bool } from "prop-types";

const scheduleGetError = (bool) => {
  return {
    type: SCHEDULE_GET_ERROR,
    scheduleGetError: bool,
  };
};

const scheduleGetLoading = (bool) => {
  return {
    type: SCHEDULE_GET_LOADING,
    scheduleGetLoading: bool,
  };
};

export const scheduleGetSuccess = (bool, schedules) => {
  return {
    type: SCHEDULE_GET_SUCCESS,
    scheduleGetSuccess: bool,
    schedules,
  };
};

const scheduleViewError = (bool) => {
  return {
    type: SCHEDULE_VIEW_ERROR,
    scheduleViewError: bool,
  };
};

const scheduleViewLoading = (bool) => {
  return {
    type: SCHEDULE_VIEW_LOADING,
    scheduleViewLoading: bool,
  };
};

const scheduleViewSuccess = (bool, schedule) => {
  return {
    type: SCHEDULE_VIEW_SUCCESS,
    scheduleViewSuccess: bool,
    schedule,
  };
};

const scheduleAddError = (bool) => {
  return {
    type: SCHEDULE_ADD_ERROR,
    scheduleAddError: bool,
  };
};

const scheduleAddLoading = (bool) => {
  return {
    type: SCHEDULE_ADD_LOADING,
    scheduleAddLoading: bool,
  };
};

const scheduleAddSuccess = (bool, schedule) => {
  return {
    type: SCHEDULE_ADD_SUCCESS,
    scheduleAddSuccess: bool,
    schedule,
  };
};

const scheduleDeleteError = (bool) => {
  return {
    type: SCHEDULE_DELETE_ERROR,
    scheduleDeleteError: bool,
  };
};

const scheduleDeleteLoading = (bool) => {
  return {
    type: SCHEDULE_DELETE_LOADING,
    scheduleDeleteLoading: bool,
  };
};

const scheduleDeleteSuccess = (bool, schedule) => {
  return {
    type: SCHEDULE_DELETE_SUCCESS,
    scheduleDeleteSuccess: bool,
    schedule,
  };
};

const scheduleGetBooking = (bool, schedule) => {
  return {
    type: SCHEDULE_GET_BOOKING,
    bookingGetSuccess: bool,
    schedule,
  };
};

const scheduleApproveCancelContainer = (bool, schedule) => {
  return {
    type: SCHEDULE_APPROVE_OR_CANCEL_CONTAINER,
    scheduleGetSuccess: bool,
    schedule,
  };
};

const scheduleGetContainerFromBooking = (bool, schedule) => {
  return {
    type: SCHEDULE_GET_CONTAINER_FROM_BOOKING,
    containerGetSuccess: bool,
    schedule,
  };
};

const scheduleApproveCancelBooking = (bool, schedule) => {
  return {
    type: SCHEDULE_APPROVE_CANCEL_BOOKING,
    scheduleGetSuccess: bool,
    schedule,
  };
};

const invalid = (bool, invalid) => {
  return {
    type: SCHEDULE_ADD_INVALID,
    scheduleGetInvalid: bool,
    invalid,
  };
};

const scheduleGetHistory = (bool, history) => {
  return {
    type: SCHEDULE_GET_HISTORY,
    scheduleGetHist: bool,
    history,
  };
};

const scheduleGetVoyage = (bool, voyage) => {
  return {
    type: SCHEDULE_GET_VOYAGE,
    scheduleGetVoy: bool,
    voyage,
  };
};

const scheduleUbahCommitted = (bool, committed) => {
  return {
    type: SCHEDULE_UBAH_COMMITTED,
    scheduleGetCommitted: bool,
    committed,
  };
};

export function scheduleGettingBooking(data) {
  return (dispatch) => {
    dispatch(scheduleGetBooking(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/get-booking-from-jadwal", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetBooking(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleApproveCancel(data) {
  return (dispatch) => {
    dispatch(scheduleApproveCancelContainer(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(
      BASE_URL + SCHEDULE_URL + "/approve-cancel-container-from-jadwal",
      config
    )
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleApproveCancelContainer(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleContainerFromBooking(data) {
  return (dispatch) => {
    dispatch(scheduleGetContainerFromBooking(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/get-container-from-booking", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((datas) => {
        dispatch(scheduleGetContainerFromBooking(true, datas));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleApproveCancelFromBooking(data) {
  return (dispatch) => {
    dispatch(scheduleApproveCancelBooking(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(
      BASE_URL + SCHEDULE_URL + "/approve-cancel-container-from-booking",
      config
    )
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleApproveCancelBooking(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleHistory(data) {
  return (dispatch) => {
    dispatch(scheduleGetHistory(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/get-schedule-history", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetHistory(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleVoyageFromTrayek(data) {
  return (dispatch) => {
    dispatch(scheduleGetVoyage(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/get-voyage-from-trayek", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetVoyage(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleVoyageFromJadwal(data) {
  return (dispatch) => {
    dispatch(scheduleGetVoyage(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/get-voyage-from-schedule", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetVoyage(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleCommitted(data) {
  return (dispatch) => {
    dispatch(scheduleUbahCommitted(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/change-committed", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleUbahCommitted(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleFetchAll() {
  return (dispatch) => {
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleFetchSub(supplier_id) {
  return (dispatch) => {
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/" + supplier_id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleFetchOld(params) {
  return (dispatch) => {
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/old", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleReset() {
  return (dispatch) => {
    dispatch(scheduleGetSuccess(false, null));
  };
}

export function ResetSchedule() {
  return (dispatch) => {
    dispatch(scheduleGetSuccess(true, { data: [] }));
  };
}

export function scheduleClear() {
  return (dispatch) => {
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));
  };
}

export function scheduleFetchWill(params, tokenx) {
  return (dispatch) => {
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = tokenx || localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/will", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(scheduleGetSuccess(true, data));
        } else {
          dispatch(scheduleGetError(true));
        }
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleFetchPlan(params, tokenx) {
  return (dispatch) => {
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = tokenx || localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/plan", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(scheduleGetSuccess(true, data));
        } else {
          dispatch(scheduleGetError(true));
        }
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

export function scheduleSearch(params) {
  return (dispatch) => {
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    };

    fetch(BASE_URL + SCHEDULE_URL + "/search", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        // dispatch(scheduleGetLoading(false))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleGetSuccess(true, data));
        dispatch(scheduleGetLoading(false));
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
        dispatch(scheduleGetLoading(false));
      });
  };
}

export function scheduleAdd(data) {
  return (dispatch) => {
    dispatch(scheduleAddError(false));
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + SCHEDULE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((schedule) => {
        dispatch(scheduleAddSuccess(true, schedule));
      })
      .catch((err) => {
        dispatch(scheduleAddError(true));
      });
  };
}

export const scheduleFetchOne = (id, spokeId) => {
  return (dispatch) => {
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleViewError(false));
    dispatch(scheduleViewSuccess(false, null));
    dispatch(scheduleViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    let id_spoke;
    if (
      spokeId !== null &&
      spokeId !== "null" &&
      spokeId !== "" &&
      spokeId !== undefined
    ) {
      id_spoke = `/${spokeId}`;
    } else {
      id_spoke = `/${0}`;
    }
    fetch(BASE_URL + SCHEDULE_URL + "/" + id + id_spoke, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(scheduleViewError(true));
      });
  };
};

export function scheduleUpdateExtend(data) {
  return (dispatch) => {
    dispatch(scheduleAddError(false));
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleAddLoading(true));
    dispatch(invalid(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    let formData = new FormData();

    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          // "Content-Type": "application/json",
        },
        body: formData,
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/extend", config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((schedule) => {
        if (schedule.success) {
          dispatch(scheduleAddSuccess(true, schedule));
        } else {
          dispatch(invalid(true, schedule));
        }
      })
      .catch((err) => {
        dispatch(scheduleAddError(true));
      });
  };
}

export function scheduleUpdate(data) {
  return (dispatch) => {
    dispatch(scheduleAddError(false));
    dispatch(scheduleAddSuccess(false, null));
    dispatch(scheduleAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((schedule) => {
        if (schedule.success) {
          dispatch(scheduleAddSuccess(true, schedule));
        } else {
          dispatch(scheduleAddError(true));
        }
      })
      .catch((err) => {
        dispatch(scheduleAddError(true));
      });
  };
}

export function scheduleDelete(dataPost) {
  return (dispatch) => {
    dispatch(scheduleViewSuccess(false, null));
    dispatch(scheduleDeleteError(false));
    dispatch(scheduleDeleteSuccess(false, null));
    dispatch(scheduleDeleteLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataPost),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleDeleteLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(scheduleDeleteSuccess(true, data));
      })
      .catch((err) => {
        dispatch(scheduleDeleteError(true));
      });
  };
}

export function latestSchedule(params) {
  return (dispatch) => {
    dispatch(scheduleGetSuccess(false, null));
    dispatch(scheduleGetError(false));
    dispatch(scheduleGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + SCHEDULE_URL + "/latest_schedule", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(scheduleGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(scheduleGetSuccess(true, data));
        } else {
          dispatch(scheduleGetError(true));
        }
      })
      .catch((err) => {
        dispatch(scheduleGetError(true));
      });
  };
}

// Handle Change to Plan
export const HANDLE_CHANGE_TO_PLAN_LOADING = "HANDLE_CHANGE_TO_PLAN_LOADING";
export const HANDLE_CHANGE_TO_PLAN_SUCCESS = "HANDLE_CHANGE_TO_PLAN_SUCCESS";
export const HANDLE_CHANGE_TO_PLAN_ERROR = "HANDLE_CHANGE_TO_PLAN_ERROR";

const handleChangeToPlanLoading = (bool) => {
  return {
    type: HANDLE_CHANGE_TO_PLAN_LOADING,
    handleChangeToPlanLoading: bool,
  };
};

const handleChangeToPlanSuccess = (bool, data) => {
  return {
    type: HANDLE_CHANGE_TO_PLAN_SUCCESS,
    handleChangeToPlanSuccess: bool,
    data,
  };
};

const handleChangeToPlanError = (bool) => {
  return {
    type: HANDLE_CHANGE_TO_PLAN_ERROR,
    handleChangeToPlanError: bool,
  };
};

export function handleChangeToPlan(data) {
  return (dispatch) => {
    dispatch(handleChangeToPlanLoading(true));
    dispatch(handleChangeToPlanSuccess(false, null));
    dispatch(handleChangeToPlanError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "jadwal/change-plan", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(handleChangeToPlanLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          dispatch(handleChangeToPlanSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(handleChangeToPlanError(true));
      });
  };
}

// Handle Ship Arrived
export const HANDLE_SHIP_ARRIVED_LOADING = "HANDLE_SHIP_ARRIVED_LOADING";
export const HANDLE_SHIP_ARRIVED_SUCCESS = "HANDLE_SHIP_ARRIVED_SUCCESS";
export const HANDLE_SHIP_ARRIVED_ERROR = "HANDLE_SHIP_ARRIVED_ERROR";

const handleShipArrivedLoading = (bool) => {
  return {
    type: HANDLE_SHIP_ARRIVED_LOADING,
    handleShipArrivedLoading: bool,
  };
};

const handleShipArrivedSuccess = (bool, data) => {
  return {
    type: HANDLE_SHIP_ARRIVED_SUCCESS,
    handleShipArrivedSuccess: bool,
    data,
  };
};

const handleShipArrivedError = (bool) => {
  return {
    type: HANDLE_SHIP_ARRIVED_ERROR,
    handleShipArrivedError: bool,
  };
};

export function handleShipArrived(data) {
  return (dispatch) => {
    dispatch(handleShipArrivedLoading(true));
    dispatch(handleShipArrivedSuccess(false, null));
    dispatch(handleShipArrivedError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "jadwal/kapal-tiba", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(handleShipArrivedLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          dispatch(handleShipArrivedSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(handleShipArrivedError(true));
      });
  };
}

// Get KSOP Port
export const GET_KSOP_PORT_LOADING = "GET_KSOP_PORT_LOADING";
export const GET_KSOP_PORT_SUCCESS = "GET_KSOP_PORT_SUCCESS";
export const GET_KSOP_PORT_ERROR = "GET_KSOP_PORT_ERROR";

const getKsopPortLoading = (bool) => {
  return {
    type: GET_KSOP_PORT_LOADING,
    getKsopPortLoading: bool,
  };
};

const getKsopPortSuccess = (bool, data) => {
  return {
    type: GET_KSOP_PORT_SUCCESS,
    getKsopPortSuccess: bool,
    data,
  };
};

const getKsopPortError = (bool) => {
  return {
    type: GET_KSOP_PORT_ERROR,
    getKsopPortError: bool,
  };
};

export function getKsopPort(data) {
  return (dispatch) => {
    dispatch(getKsopPortLoading(true));
    dispatch(getKsopPortSuccess(false, null));
    dispatch(getKsopPortError(false));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "get-user", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(getKsopPortLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          dispatch(getKsopPortSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(getKsopPortError(true));
      });
  };
}

// TRAYEK LIST
export const GET_TRAYEK_LIST_SUCCESS = "GET_TRAYEK_LIST_SUCCESS";
export const GET_TRAYEK_LIST_LOADING = "GET_TRAYEK_LIST_LOADING";
export const GET_TRAYEK_LIST_ERROR = "GET_TRAYEK_LIST_ERROR";

const getTrayekListLoading = (bool) => {
  return {
    type: "GET_TRAYEK_LIST_LOADING",
    getTrayekListLoading: bool,
  };
};

const getTrayekListError = (bool) => {
  return {
    type: "GET_TRAYEK_LIST_ERROR",
    getTrayekListLoading: bool,
  };
};

const getTrayekListSuccess = (bool, data) => {
  return {
    type: "GET_TRAYEK_LIST_SUCCESS",
    getTrayekListLoading: bool,
    data,
  };
};

export function getTrayekList(data) {
  return (dispatch) => {
    dispatch(getTrayekListLoading(true));
    dispatch(getTrayekListError(false));
    dispatch(getTrayekListSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "transfer-quota/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(getTrayekListLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          dispatch(getTrayekListSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(getTrayekListError(true));
      });
  };
}

// JADWAL LIST
export const GET_JADWAL_LIST_SUCCESS = "GET_JADWAL_LIST_SUCCESS";
export const GET_JADWAL_LIST_LOADING = "GET_JADWAL_LIST_LOADING";
export const GET_JADWAL_LIST_ERROR = "GET_JADWAL_LIST_ERROR";

const getJadwalListLoading = (bool) => {
  return {
    type: "GET_JADWAL_LIST_LOADING",
    getJadwalListLoading: bool,
  };
};

const getJadwalListError = (bool) => {
  return {
    type: "GET_JADWAL_LIST_ERROR",
    getJadwalListLoading: bool,
  };
};

const getJadwalListSuccess = (bool, data) => {
  return {
    type: "GET_JADWAL_LIST_SUCCESS",
    getJadwalListLoading: bool,
    data,
  };
};

export function getJadwalList(data) {
  return (dispatch) => {
    dispatch(getJadwalListLoading(true));
    dispatch(getJadwalListError(false));
    dispatch(getJadwalListSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "transfer-quota/jadwal", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(getJadwalListLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          dispatch(getJadwalListSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(getJadwalListError(true));
      });
  };
}

// GET QUOTA LIST
export const GET_QUOTA_LIST_SUCCESS = "GET_QUOTA_LIST_SUCCESS";
export const GET_QUOTA_LIST_LOADING = "GET_QUOTA_LIST_LOADING";
export const GET_QUOTA_LIST_ERROR = "GET_QUOTA_LIST_ERROR";

const getQuotaListLoading = (bool) => {
  return {
    type: "GET_QUOTA_LIST_LOADING",
    getQuotaListLoading: bool,
  };
};

const getQuotaListError = (bool) => {
  return {
    type: "GET_QUOTA_LIST_ERROR",
    getQuotaListLoading: bool,
  };
};

const getQuotaListSuccess = (bool, data) => {
  return {
    type: "GET_QUOTA_LIST_SUCCESS",
    getQuotaListLoading: bool,
    data,
  };
};

export function getQuotaList(data) {
  return (dispatch) => {
    dispatch(getQuotaListLoading(true));
    dispatch(getQuotaListError(false));
    dispatch(getQuotaListSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "transfer-quota/quota", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(getQuotaListLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          dispatch(getQuotaListSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(getQuotaListError(true));
      });
  };
}

// UPDATE QUOTA LIST
export const UPDATE_QUOTA_SUCCESS = "UPDATE_QUOTA_SUCCESS";
export const UPDATE_QUOTA_LOADING = "UPDATE_QUOTA_LOADING";
export const UPDATE_QUOTA_ERROR = "UPDATE_QUOTA_ERROR";

const updateQuotaLoading = (bool) => {
  return {
    type: UPDATE_QUOTA_LOADING,
    updateQuotaLoading: bool,
  };
};

const updateQuotaError = (bool) => {
  return {
    type: UPDATE_QUOTA_ERROR,
    updateQuotaError: bool,
  };
};

const updateQuotaSuccess = (bool, data) => {
  return {
    type: UPDATE_QUOTA_SUCCESS,
    updateQuotaSuccess: bool,
    data,
  };
};

export function updateQuota(data) {
  return (dispatch) => {
    dispatch(updateQuotaLoading(true));
    dispatch(updateQuotaError(false));
    dispatch(updateQuotaSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + "transfer-quota/update", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(updateQuotaLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          dispatch(updateQuotaSuccess(true, data));
        } else {
          alert(data.message);
        }
      })
      .catch((err) => {
        dispatch(updateQuotaError(true));
      });
  };
}
